"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionItemsWrapper = exports.SubscriptionItemPlusWrapper = exports.SkeletonRoot = exports.OnlyMobile = exports.OnlyDesktop = exports.Description = exports.CombineSectionContent = exports.CombineSectionButton = exports.CombineContentWrapper = exports.CheckoutImageWrapper = void 0;
var _mui = require("@ori-ui/mui");
const CombineSectionButton = exports.CombineSectionButton = (0, _mui.styled)(_mui.ButtonBase)(({
  theme
}) => ({
  background: theme.palette.background.paper,
  padding: theme.spacing(3),
  textAlign: 'left',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(6),
    borderRadius: theme.shape.largeComponentRadius
  }
}));
const CombineSectionContent = exports.CombineSectionContent = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(3),
  cursor: 'pointer'
}));
const CombineContentWrapper = exports.CombineContentWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4)
}));
const Description = exports.Description = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}));
const SubscriptionItemsWrapper = exports.SubscriptionItemsWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  gap: theme.spacing(1)
}));
const CheckoutImageWrapper = exports.CheckoutImageWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden'
}));
const SubscriptionItemPlusWrapper = exports.SubscriptionItemPlusWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '80px',
  height: '80px',
  border: `1px solid ${theme.palette.grey[200]}`,
  background: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxSizing: 'border-box',
  overflow: 'hidden'
}));
const OnlyMobile = exports.OnlyMobile = (0, _mui.styled)('div')(({
  theme
}) => ({
  [theme.breakpoints.up('sm')]: {
    display: 'none'
  }
}));
const OnlyDesktop = exports.OnlyDesktop = (0, _mui.styled)('div')(({
  theme
}) => ({
  [theme.breakpoints.down('sm')]: {
    display: 'none'
  }
}));
const SkeletonRoot = exports.SkeletonRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  background: theme.palette.background.paper,
  padding: theme.spacing(3),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(6),
    borderRadius: theme.shape.largeComponentRadius
  }
}));